import React, { useState } from "react";
import {
  Box,
  DatePickerInput,
  InputField,
  SubmitButton,
  TextComponent,
  TextareaField,
  TimePickerInput,
} from "../../../../components";
import { useLocation } from "react-router-dom";
import styles from "./Screen4.module.css";
import { BiSolidPlusCircle } from "react-icons/bi";
import Modal from "../../../../components/modal/Modal";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { useDispatch, useSelector } from "react-redux";
import { List } from "antd";
import moment from "moment";
import { CalendarIcon, ClockIcon } from "../../../../components/icons/Icons";
import AutoCompleteInput from "../../../../components/auntoCompleteInput/AutoCompleteInput";
import { IoLocation } from "react-icons/io5";
import { EventMiddleware } from "../../../../Store/Middlewares/EventMiddleware";
import dayjs from "dayjs";
import { CgClose } from "react-icons/cg";

const Screen4 = ({ setCurrentStep }) => {
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);
  const [isModalOpen, setIsModalOpen] = useState(
    WeddingWeb?.agendas?.length > 0 ? false : true
  );
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [id, setId] = useState();
  const [title, setTitle] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [time, setTime] = useState("");
  const [locationName, setLocationName] = useState("");
  const [address, setAddress] = useState("");
  //   const [address, setAddress] = useState("");
  const [desc, setDesc] = useState("");
  const [detailsArr, setDetailsArr] = useState(
    WeddingWeb?.agendas?.length > 0 ? WeddingWeb?.agendas : []
  );
  // const [editItem, setEditItem] = useState();
  console.log("address", address);
  const dispatch = useDispatch();
  const onClickNext = () => {
    if (detailsArr.length == 0) {
      dispatch(
        showAlert({
          type: "Error",
          message: "Please Add atleast one detail",
        })
      );
    } else {
      dispatch(
        EventMiddleware.postWeddingWebsite({
          step: 4,
          weddingWebId: WeddingWeb?.id,
          detailsArr,
        })
      ).then(() => setCurrentStep((prev) => prev + 1));
      // setCurrentStep((prev) => prev + 1);
    }
  };
  const saveDetails = () => {
    if (!title || !eventDate || !time || !locationName || !address || !desc) {
      dispatch(
        showAlert({
          type: "Error",
          message: "All fields are mandatory",
        })
      );
    } else {
      let dummyArr = [...detailsArr];
      dummyArr.push({
        id: detailsArr?.length + 1,
        title: title,
        date: eventDate,
        time: time,
        // date: moment(eventDate?.$d).format("MM/DD/YYYY"),
        // time: moment(time?.$d).format("HH:mm"),
        location_title: locationName,
        location: address.address,
        lat: address.lat,
        lng: address.lng,
        description: desc,
      });
      setDetailsArr(dummyArr);
      setIsModalOpen(false);
      setTitle("");
      setEventDate("");
      setTime("");
      setLocationName("");
      setAddress("");
      setDesc("");
      setId();
    }
  };
  const onClickEditBtn = (item) => {
    setIsEditModalOpen(true);
    setId(item?.id);
    setTitle(item?.title);
    setEventDate(dayjs(item?.date?.$d ? item?.date?.$d : item?.date));
    setTime(
      dayjs(`${item?.time?.$d ? item?.time?.$d : `${item?.date + item?.time}`}`)
    );
    setLocationName(item?.location_title);
    setAddress({ address: item?.location, lat: item.lat, lng: item.lng });
    setDesc(item?.description);
  };
  const editDetails = () => {
    let data = {
      id: id,
      title: title,
      date: eventDate,
      time: time,
      // date: moment(eventDate?.$d).format("MM/DD/YYYY"),
      // time: moment(time?.$d).format("HH:mm"),
      location_title: locationName,
      location: address.address,
      lat: address.lat,
      lng: address.lng,
      description: desc,
    };
    let index = detailsArr.findIndex((item) => item?.id == id);
    setDetailsArr((prev) => {
      prev.splice(index, 1, data);
      return prev;
    });
    setIsEditModalOpen(false);
    setTitle("");
    setEventDate("");
    setTime("");
    setLocationName("");
    setAddress("");
    setDesc("");
    setId();
  };

  const renderItem = (item, index) => {
    console.log(item?.time);
    return (
      <div className={styles.listItem} key={index}>
         <CgClose
          className={styles.crossIcon}
          size={20}
          onClick={() => {
            setDetailsArr((prev) => {
              let newArr = [...prev];
              newArr.splice(index, 1);
              return newArr;
            });
          }}
        />
        <TextComponent text={item?.title} textClass={styles.title} />
        <TextComponent
          text={item?.location_title}
          textClass={styles.locationName}
        />
        <div className={styles.twoDivs}>
          <div className={styles.subTwoDivs}>
            <CalendarIcon size={25} />
            <TextComponent text={"Date"} textClass={styles.datetimeTxt} />
            <TextComponent
              text={moment(item?.date?.$d ? item?.date?.$d : item?.date).format(
                "MMMM D, YYYY"
              )}
              textClass={styles.dateTime}
            />
          </div>
          <div className={styles.subTwoDivs}>
            <ClockIcon size={25} />
            <TextComponent text={"Start Time"} textClass={styles.datetimeTxt} />
            <TextComponent
              text={moment(
                item?.time?.$d ? item?.time?.$d : item?.time,
                "HHmmss"
              ).format("hh:mm a")}
              textClass={styles.dateTime}
            />
          </div>
        </div>
        <div className={styles.addressDiv}>
          <IoLocation size={25} color="var(--primary-color)" />
          <TextComponent text={item?.location} textClass={styles.address} />
        </div>
        <TextComponent
          text={"Edit"}
          textClass={styles.editBtn}
          onClick={() => onClickEditBtn(item)}
        />
      </div>
    );
  };
  return (
    <>
      <div className={styles.content}>
        <div className={styles.textCont}>
          <TextComponent text={"Agenda"} />
        </div>
      </div>
      {detailsArr && (
        <div className={styles.listDiv}>
          <List
            grid={{ lg: 2, xxl: 2, xl: 2, xs: 1, md: 2, sm: 1 }}
            dataSource={detailsArr}
            renderItem={renderItem}
            className={styles.list}
          />
        </div>
      )}
      <div className={styles.content}>
        <div className={styles.addBtn} onClick={() => setIsModalOpen(true)}>
          <BiSolidPlusCircle className={styles.addIcon} />
          <TextComponent text={"Add"} />
        </div>
        <div className={styles.nextBtn}>
          <SubmitButton title={"Next"} onClick={onClickNext} />
        </div>
      </div>

      {isModalOpen && (
        <Modal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          closable={true}
          pinkBg={true}
          // wideModal={true}
          className={styles.modalContent}
        >
          <div className={styles.modalDiv}>
            <InputField
              placeholder={"Title"}
              onChange={(e) => setTitle(e.target.value)}
              value={title}
            />
            <div className={styles.twoInputs}>
              <DatePickerInput
                placeholder={"Event Date"}
                // label="Set Date"
                // inputWidth="49%"
                className={styles.inputs}
                value={eventDate}
                onChange={(e) => setEventDate(e)}
                icon={<CalendarIcon size={25} />}
              />
              <TimePickerInput
                placeholder={"Start Time"}
                className={styles.inputs}
                // label="Start Time"
                // inputWidth="49%"
                value={time}
                onChange={(e) => setTime(e)}
                icon={<ClockIcon size={25} />}
              />
            </div>
            <div className={styles.twoInputs}>
              <InputField
                styles={styles.inputs}
                // inputWidth="49%"
                placeholder={"Location Name"}
                onChange={(e) => setLocationName(e.target.value)}
                value={locationName}
              />
              <AutoCompleteInput
                className={styles.inputs}
                // label={"Address"}
                placeholder={"Address"}
                address={address?.address}
                onSelectPlace={(place) => {
                  let currentLocation = {
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address,
                  };
                  setAddress(currentLocation);
                }}
                // onChange={(e) => setAddress(e.target.value)}
              />
            </div>
            <TextareaField
              placeholder={"Write Here"}
              onChange={(e) => setDesc(e.target.value)}
              value={desc}
            />
            <div className={styles.btnDiv}>
              <SubmitButton
                title={"Save"}
                btnClass={styles.saveBtn}
                onClick={saveDetails}
              />
            </div>
          </div>
        </Modal>
      )}
      {isEditModalOpen && (
        <Modal
          isModalOpen={isEditModalOpen}
          setIsModalOpen={setIsEditModalOpen}
          closable={true}
          pinkBg={true}
          onClose={() => {
            setId();
            setTitle("");
            setDesc("");
            setTime("");
            setEventDate("");
            setLocationName("");
            setAddress("");
          }}
          // wideModal={true}
          className={styles.modalContent}
        >
          <div className={styles.modalDiv}>
            <InputField
              placeholder={"Title"}
              onChange={(e) => setTitle(e.target.value)}
              value={title}
            />
            <div className={styles.twoInputs}>
              <DatePickerInput
                placeholder={"Event Date"}
                // label="Set Date"
                // inputWidth="49%"
                className={styles.inputs}
                value={eventDate}
                onChange={(e) => setEventDate(e)}
                icon={<CalendarIcon size={25} />}
              />
              <TimePickerInput
                placeholder={"Start Time"}
                className={styles.inputs}
                // label="Start Time"
                // inputWidth="49%"
                value={time}
                onChange={(e) => setTime(e)}
                icon={<ClockIcon size={25} />}
              />
            </div>
            <div className={styles.twoInputs}>
              <InputField
                styles={styles.inputs}
                // inputWidth="49%"
                placeholder={"Location Name"}
                onChange={(e) => setLocationName(e.target.value)}
                value={locationName}
              />
              <AutoCompleteInput
                className={styles.inputs}
                // label={"Address"}
                placeholder={"Address"}
                address={address?.address}
                onSelectPlace={(place) => {
                  let currentLocation = {
                    lat: place?.geometry?.location?.lat(),
                    lng: place?.geometry?.location?.lng(),
                    address: place?.formatted_address,
                  };
                  setAddress(currentLocation);
                }}
              />
            </div>
            <InputField
              placeholder={"Write Here"}
              onChange={(e) => setDesc(e.target.value)}
              value={desc}
            />
            <div className={styles.btnDiv}>
              <SubmitButton
                title={"Save"}
                btnClass={styles.saveBtn}
                onClick={editDetails}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default Screen4;
